// Balcão → Delivery (pedido do dono, 29/09/2026). Na mercearia, "Entrega" no
// Balcão leva o carrinho para o Novo Pedido do Delivery, que já tem cliente,
// endereço, taxa por bairro, entregador e cupom de entrega. A passagem vai pelo
// sessionStorage (mesma aba, some ao fechar). Desde 30/09/2026 ler não apaga:
// um F5 ou o Novo Pedido fechado sem gravar não perdem os produtos. Quem apaga
// é o Delivery, com `apagarPassagem()`, quando o pedido é criado.
const CHAVE = "nucleo:balcao_para_delivery";
const VALIDADE_MS = 10 * 60 * 1000;

// Carrinho do Balcão → formato do carrinho do Novo Pedido: o mesmo que ele
// monta ao editar um pedido (preço final em `sale_price`, escolhas das etapas
// em `subitems`/`etapas`, como o Balcão mandaria no próprio pedido).
export function itensParaDelivery(cart, { getItemSubitems, getItemStepsSummary }) {
  return (cart || []).map((item) => ({
    id: item.id,
    name: item.name,
    quantity: item.quantity,
    sale_price: item.final_price || item.sale_price || 0,
    observation: item.observation || "",
    photo_url: item.photo_url || null,
    subitems: getItemSubitems(item) || [],
    etapas: getItemStepsSummary(item) || [],
    combo_type: item.combo_type || null,
    etiqueta_balanca: item.etiqueta_balanca || null,
    sale_unit: item.sale_unit || "un",
    is_divisible: !!item.is_divisible,
    category: item.category || null,
  }));
}

// `desconto` (30/09/2026): o do carrinho do Balcão — {tipo: "percent"|"fixed"|
// "coupon", valor, cupom} — que o Novo Pedido aplica igual.
export function guardarPassagem({ itens, cliente = null, nome = "", desconto = null }) {
  try {
    sessionStorage.setItem(CHAVE, JSON.stringify({ itens, cliente, nome, desconto, em: Date.now() }));
    return true;
  } catch {
    return false;
  }
}

export function temPassagem() {
  return !!lerPassagem();
}

// Lê SEM apagar. Passagem velha (mais de 10 min) ou vazia é descartada aqui.
export function lerPassagem() {
  try {
    const bruto = sessionStorage.getItem(CHAVE);
    const p = bruto ? JSON.parse(bruto) : null;
    if (!p || !Array.isArray(p.itens) || !p.itens.length || Date.now() - (p.em || 0) > VALIDADE_MS) {
      if (bruto) sessionStorage.removeItem(CHAVE);
      return null;
    }
    return p;
  } catch {
    return null;
  }
}

// O Delivery chama depois que o Novo Pedido GRAVOU o pedido (POST aceito). Sem
// isto a passagem continua valendo até vencer (10 min) e o Novo Pedido abriria
// de novo com os mesmos produtos.
export function apagarPassagem() {
  try { sessionStorage.removeItem(CHAVE); } catch { /* nada a fazer */ }
}
